import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CATEGORY_PROP_TYPE } from '../utils/props';
import { getAuctionListFullUrl } from '../utils/urls';

const AuctionCategories = ({ className, categories }) => {
    if (!categories || !categories.length || !categories.slice) {
        return null;
    }

    return (
        <div className={'al-auction-categories ' + (className || '')}>
            {categories.map(function(cat) {
                return (
                    <Link
                        className="al-category-tag"
                        to={getAuctionListFullUrl(1, cat.value)}
                        key={cat.value}
                    >
                        {cat.display}
                    </Link>
                );
            })}
        </div>
    );
};

AuctionCategories.propTypes = {
    className: PropTypes.string,
    categories: PropTypes.arrayOf(CATEGORY_PROP_TYPE),
};

export default AuctionCategories;
